import { useLang } from "@/i18n/LanguageContext";

const PARTNERS = [
  "MEDTRONIC", "INTUITIVE", "PHILIPS", "SIEMENS", "GE HEALTHCARE",
  "OPENAI", "BOSTON DYNAMICS", "JOHNSON & JOHNSON", "ROCHE", "SAMSUNG MEDISON",
  "ABB ROBOTICS", "STRYKER", "OLYMPUS", "FANUC", "FRESENIUS",
];

export default function Partners() {
  const { t } = useLang();
  const P = t.partners;
  const row = [...PARTNERS, ...PARTNERS];
  return (
    <section
      id="partners"
      data-testid="partners-section"
      className="relative border-b border-white/10 py-24"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-6 mb-12">
          <div className="col-span-12 lg:col-span-8">
            <div className="label-mono mb-4">{P.label}</div>
            <h2 className="display-2 text-3xl md:text-4xl text-white">
              {P.title_a}
              <br />
              <span className="text-white/40">{P.title_muted}</span>{" "}
              <span className="text-[#FF3333]">{P.title_accent}</span>
            </h2>
          </div>
        </div>
      </div>

      <div className="overflow-hidden border-y border-white/10 py-10">
        <div className="marquee">
          {row.map((p, i) => (
            <div key={i} className="flex items-center shrink-0 px-10">
              <span className="font-display font-bold text-2xl md:text-3xl tracking-tight text-white/30 hover:text-white transition-colors whitespace-nowrap">
                {p}
              </span>
              <span className="text-[#FF3333] font-mono text-xs ml-10">◢</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
